import React, { useRef } from "react";
import LoadingAnime from "../reusble_components/loadingAnime";
export default function JobApplicantsShimmer() {
  const topRef = useRef(null);

  const scrollToTop = () => {
    topRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <div className="outerbox flex">
        <div className="leftload w-[23%] max-md:w-[100%]">
          <LoadingAnime
            page={"JobApplicants"}
            boxHeight="14rem"
            gridColumns="grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1"
            innerBoxes={[
              //circle top
              {
                width: "2.5rem",
                height: "2.5rem",
                color: "bg-gray-400",
                shape: "circle",
                top: "0%",
                left: "0%",
              },
              //top 3 boxes
              {
                width: "77%",
                height: "12%",
                color: "bg-gray-400",
                shape: "rectangle",
                top: "5%",
                left: "23%",
              },
              {
                width: "62%",
                height: "10%",
                color: "bg-gray-400",
                shape: "rectangle",
                top: "26%",
                left: "23%",
              },
              {
                width: "47%",
                height: "7%",
                color: "bg-gray-400",
                shape: "rectangle",
                top: "18%",
                left: "23%",
              },
              //-----------------------------------

              //middle three squares
              {
                width: "21%",
                height: "23%",
                color: "bg-gray-400",
                shape: "rectangle",
                bottom: "32%",
                left: "0%",
              },
              {
                width: "21%",
                height: "10%",
                color: "bg-gray-400",
                shape: "rectangle",
                bottom: "20%",
                left: "0%",
              },
              {
                width: "21%",
                height: "23%",
                color: "bg-gray-400",
                shape: "rectangle",
                bottom: "32%",
                left: "32%",
              },
              {
                width: "21%",
                height: "10%",
                color: "bg-gray-400",
                shape: "rectangle",
                bottom: "20%",
                left: "32%",
              },
              {
                width: "21%",
                height: "23%",
                color: "bg-gray-400",
                shape: "rectangle",
                bottom: "32%",
                left: "63%",
              },
              {
                width: "21%",
                height: "10%",
                color: "bg-gray-400",
                shape: "rectangle",
                bottom: "20%",
                left: "63%",
              },
              //-----------------bottom------------
              {
                width: "36%",
                height: "12%",
                color: "bg-gray-400",
                shape: "rectangle",
                bottom: "0%",
                left: "0%",
              },
            ]}
          />
        </div>
        <div className="rightload w-[75%] max-md:hidden">
          <RightLoad />
        </div>
      </div>
    </>
  );
}

export function RightLoad() {
  return (
    <LoadingAnime
      numBoxes={1}
      page={"JobApplicants"}
      boxHeight="90vh"
      gridColumns="grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1"
      innerBoxes={[
        //circle top
        {
          width: "7rem",
          height: "7rem",
          color: "bg-gray-400",
          shape: "circle",
          top: "0%",
          left: "0%",
        },
        //top 3 boxes
        {
          width: "33%",
          height: "8%",
          color: "bg-gray-400",
          shape: "rectangle",
          top: "5%",
          left: "16%",
        },
        {
          width: "23%",
          height: "4%",
          color: "bg-gray-400",
          shape: "rectangle",
          top: "14%",
          left: "16%",
        },
        {
          width: "40%",
          height: "8%",
          color: "bg-gray-400",
          shape: "rectangle",
          top: "19%",
          left: "16%",
        },
        {
          width: "15%",
          height: "8%",
          color: "bg-gray-400",
          shape: "rectangle",
          top: "13%",
          right: "2%",
        },
        {
          width: "11%",
          height: "6%",
          color: "bg-gray-400",
          shape: "rectangle",
          top: "0%",
          right: "0%",
        },
        //-----------------------------------

        // middle three squares
        //left
        {
          width: "18%",
          height: "5%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "48%",
          left: "5%",
        },
        {
          width: "18%",
          height: "5%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "42%",
          left: "5%",
        },
        {
          width: "18%",
          height: "5%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "36%",
          left: "5%",
        },
        {
          width: "6rem",
          height: "6rem",
          color: "bg-gray-400",
          shape: "circle",
          bottom: "36%",
          left: "25%",
        },
        //--------------------
        {
          width: "0.2%",
          height: "22%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "36%",
          left: "36.5%",
        },

        //--------------------
        {
          width: "21%",
          height: "5%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "48%",
          left: "42%",
        },

        {
          width: "21%",
          height: "5%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "42%",
          left: "42%",
        },

        {
          width: "21%",
          height: "5%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "36%",
          left: "42%",
        },
        //------------------------
        {
          width: "0.2%",
          height: "22%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "36%",
          left: "67.5%",
        },

        //-------------------------
        {
          width: "21%",
          height: "5%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "48%",
          left: "72%",
        },
        {
          width: "21%",
          height: "5%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "42%",
          left: "72%",
        },
        {
          width: "21%",
          height: "5%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "36%",
          left: "72%",
        },

        //-----------------bottom------------
        {
          width: "28%",
          height: "7%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "18%",
          left: "0%",
        },
        {
          width: "33%",
          height: "12%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "0%",
          left: "0%",
        },
        {
          width: "33%",
          height: "12%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "0%",
          left: "34%",
        },
        {
          width: "33%",
          height: "12%",
          color: "bg-gray-400",
          shape: "rectangle",
          bottom: "0%",
          left: "68%",
        },
      ]}
    />
  );
}
